module.exports = __webpack_public_path__ + "img/bespoke123_18.072ca278.jpg";